import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20group%20of%20Chinese%20elderly%20women%20sitting%20together%20in%20a%20sunlit%20garden%2C%20laughing%20and%20chatting%2C%20warm%20golden%20afternoon%20light%2C%20flowers%20in%20background%2C%20soft%20and%20dreamy%20atmosphere%2C%20natural%20connection%20between%20friends%2C%20artistic%20photography%20with%20gentle%20bokeh%2C%20warm%20pastel%20tones%2C%20emotional%20and%20heartwarming%20scene%2C%20elegant%20composition%20with%20soft%20shadows&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="妈妈的朋友们 - 温情故事与情感共鸣"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40"></div>
      </div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 md:mb-6 leading-tight">
            妈妈的朋友们
          </h1>
          <p className="text-sm md:text-lg text-white/90 max-w-xl mx-auto leading-relaxed mb-6 md:mb-8">
            在这里，发现母辈女性友情的动人故事<br className="hidden md:block" />
            感受岁月沉淀下的情感共鸣与生命力量
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/mama-yu-guimi"
              className="inline-flex items-center px-6 py-3 bg-primary-500 text-white rounded-full font-label text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              探索故事
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center px-6 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full font-label text-sm hover:bg-white/30 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/60 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}